/* ============================================================
   Bushnell Sim Fit Check — entry points — July 2026
   Injects "Check your space" entries on:
   - /collections/simulators (gateway card after the hero)
   - Simulator PDPs (link under the price/installments)
   - Mega menu simulators panel (card under the bundle links)
   The tool itself lives at /pages/sim-fit-check
   (sections/bushnell-sim-fit-check.liquid).
   Fail-safe: every module wrapped so an error never breaks the page.
   ============================================================ */
(function () {
  var FIT_URL = '/pages/sim-fit-check';

  var RULER_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="#FE5000" stroke-width="2" width="18" height="18"><path d="M21.3 8.7l-6-6a1 1 0 0 0-1.4 0l-11 11a1 1 0 0 0 0 1.4l6 6a1 1 0 0 0 1.4 0l11-11a1 1 0 0 0 0-1.4z"/><path d="M7.5 10.5l1.5 1.5"/><path d="M10.5 7.5l1.5 1.5"/><path d="M13.5 4.5l1.5 1.5"/></svg>';
  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="#FE5000" stroke-width="2" width="18" height="18" style="flex-shrink:0;"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  function card(variant) {
    var a = document.createElement('a');
    a.className = 'bn-fitcheck-card bn-fitcheck-card--' + variant;
    a.href = FIT_URL;
    a.innerHTML =
      '<span class="bn-fitcheck-card__pip">' + RULER_SVG + '</span>' +
      '<span class="bn-fitcheck-card__copy">' +
      '<span class="bn-fitcheck-card__title">Will it fit? Check your space</span>' +
      '<span class="bn-fitcheck-card__sub">3 measurements &#8594; the right enclosure, in 30 seconds</span>' +
      '</span>' + ARROW_SVG;
    return a;
  }

  /* Collection — /collections/simulators already has a "Space Requirements"
     tile, guide section, and expert bar. Don't add a fourth element: repoint
     the existing "Check your space" CTAs at the interactive tool instead. */
  function initCollection() {
    try {
      if (!/\/collections\/(simulators|simulator-bundles)(\/|$)/.test(location.pathname)) return;
      document.querySelectorAll('a').forEach(function (a) {
        if (/check\s+your\s+space/i.test(a.textContent || '')) a.href = FIT_URL;
      });
    } catch (err) { /* fail-safe */ }
  }

  /* PDP link — simulator bundle product pages */
  function initPdp() {
    try {
      var title = document.querySelector('.bpdp-title, #MainContent h1');
      if (!title || !/simulator/i.test(title.textContent || '')) return;
      if (document.querySelector('.bn-fitcheck-link')) return;
      /* Prefer placing the link right before the variant selector; fall back to
         just after the price/installments if the variants block isn't present. */
      var variants = document.querySelector('.bpdp-variants');
      var anchor = document.querySelector('.bn-installments') || document.querySelector('.bpdp-price');
      if (!variants && !anchor) return;
      var a = document.createElement('a');
      a.className = 'bn-fitcheck-link';
      a.href = FIT_URL;
      a.innerHTML = RULER_SVG + ' Not sure which size? Check your space';
      if (variants) {
        variants.insertAdjacentElement('beforebegin', a);
      } else if (anchor) {
        anchor.insertAdjacentElement('afterend', a);
      }
    } catch (err) { /* fail-safe */ }
  }

  /* Mega menu — simulators panel */
  function initMegaMenu() {
    try {
      var panel = document.querySelector('[data-mega-panel="bn-simulators"], [data-mega-panel="simulators"], [data-mega-panel="SIMULATOR"], [data-mega-panel*="imulator"]');
      if (!panel || panel.querySelector('.bn-fitcheck-card--menu')) return;
      var container = panel.querySelector('.container') || panel;
      /* Sit under the bundle link list when one exists; in the comparison
         layout (no link column) go full-width above the panel footer. */
      var linkCol = container.querySelector('.mega-menu-links, .mega-menu-col');
      if (linkCol) {
        linkCol.appendChild(card('menu'));
      } else {
        var footer = container.querySelector('.mega-menu-footer');
        if (footer) {
          footer.insertAdjacentElement('beforebegin', card('menu'));
        } else {
          container.appendChild(card('menu'));
        }
      }
    } catch (err) { /* fail-safe */ }
  }

  function initAll() { initCollection(); initPdp(); initMegaMenu(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
